/* BI-03 · QUOTA & SAFE PAUSE
   L5: the allocation is an abuse ceiling. The safe pause never strands a
   customer mid-journey, and never bills by surprise. */
import { Button, Card, KV, Note } from '@/ui'
import { Head, useBill } from './ParamShell'

export default function BI03Utilisation() {
  const u = useBill().usage
  return (
    <section data-frame="BI-03" style={{ display: 'grid', gap: 14 }}>
      <Head title="Utilisation — août" />
      <Card>
        <KV rows={[['Participations valides', <><strong>{u.valid}</strong>{u.location}</>]]} />
      </Card>
      {/* the wireframe’s quota bar; @/ui has no meter component — logged in
          Builder_B_Status. Tokens only, no one-off CSS. */}
      <div style={{ height: 8, borderRadius: 5, background: 'var(--bmr-border)', overflow: 'hidden' }}
        role="img" aria-label={`${u.percentLabel} du quota`}>
        <div style={{ height: '100%', width: `${u.percent}%`, background: 'var(--bmr-warn)' }} />
      </div>
      <Note tone="candour">
        {u.percentLabel} de votre quota — alerte envoyée à 80 % et 100 %. Au-delà : ~20 % de marge
        de tolérance, puis <strong>pause de sécurité</strong>. Jamais de facturation surprise.
      </Note>
      <Card>
        <strong>En pause de sécurité :</strong> un client déjà engagé termine son parcours
        normalement ; les nouveaux scans voient une page d’attente claire côté client. Cadeaux,
        Mes cadeaux et validations continuent. Reprise : remise à zéro le 1ᵉʳ, montée d’offre ou
        accord.
      </Card>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="primary" size="sm">Passer à l’offre supérieure</Button>
        <Button variant="quiet" size="sm">Voir le détail par jour</Button>
      </div>
    </section>
  )
}
